import { useMemo } from 'react';
import { Col, Image, Row, Spinner } from 'react-bootstrap';
import { FaMapMarkerAlt } from 'react-icons/fa';
import {
  eastCreteFallbackImages,
  getEastCreteDestinationImage,
  useEastCreteDestinations
} from '@/views/home/components/DiscoverSouthCrete';

const AreaHighlights = () => {
  const { destinations, loading, error } = useEastCreteDestinations();

  const displayDestinations = useMemo(() => {
    if (!destinations || destinations.length === 0) return [];
    return destinations.slice(0, 6);
  }, [destinations]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center py-4">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (error && displayDestinations.length === 0) {
    return null;
  }

  if (displayDestinations.length === 0) {
    return null;
  }

  return (
    <Row className="g-4 g-lg-5 mt-4">
      {displayDestinations.map((destination, idx) => {
        const imageUrl = getEastCreteDestinationImage(destination, idx);
        return (
          <Col key={destination.id ?? idx} sm={6} lg={4}>
            <div className="h-100 border border-light-subtle rounded-4 shadow-sm overflow-hidden bg-white">
              <div className="position-relative">
                <Image
                  src={imageUrl}
                  alt={destination.name || `East Crete area ${idx + 1}`}
                  className="w-100"
                  style={{ height: 220, objectFit: 'cover' }}
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = eastCreteFallbackImages[idx % eastCreteFallbackImages.length];
                  }}
                />
                <span className="position-absolute top-0 start-0 m-3 px-3 py-1 rounded-pill bg-white text-primary fw-semibold shadow-sm small">
                  {String(idx + 1).padStart(2, '0')}
                </span>
              </div>
              <div className="p-4">
                <h5 className="fw-semibold mb-1">{destination.name}</h5>
                {destination.location && (
                  <div className="d-flex align-items-center text-muted small mb-3">
                    <FaMapMarkerAlt className="text-primary me-2" />
                    <span>{destination.location}</span>
                  </div>
                )}
                {destination.description && (
                  <p
                    className="text-muted small mb-0"
                    style={{
                      display: '-webkit-box',
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden'
                    }}
                    dangerouslySetInnerHTML={{ __html: destination.description }}
                  />
                )}
              </div>
            </div>
          </Col>
        );
      })}
    </Row>
  );
};

export default AreaHighlights;


